import { useMemo } from 'react';
import { DataSourceLabel, ExtraId } from '@/common/apis/dtos';
import ControlledTooltip from '@/common/components/controlled-tooltip/ControlledTooltip';
import { InformationDisplay } from '@/common/components/information-display/InformationDisplay';
import { getDisplayValue } from './utils';
import { Box, Typography } from '@mui/material';

export interface ExtraIdItemProps {
  value: ExtraId | undefined;
  dataSourceLabel: DataSourceLabel | undefined;
}

export const ExtraIdItem = ({ value, dataSourceLabel }: ExtraIdItemProps) => {
  const displayValue = useMemo(
    () => value ? getDisplayValue(value.extraIdValues) : '',
    [value?.extraIdValues]
  );

  // if no value is provided, return an empty div
  // this is for situations when some positions are not set by user
  if (!value) {
    return <Box></Box>;
  }

  const label = value.customDisplayLabel || dataSourceLabel?.label || value.label || 'Unknown Label';
  return (
      <InformationDisplay
        label={label}
        component={
          <ControlledTooltip title={displayValue}>
            <Typography
              variant="body100"
              noWrap
              sx={{
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontWeight: '500',
              }}
            >
              {displayValue}
            </Typography>
          </ControlledTooltip>
        }
      />
  );
};
